import angular from 'angular';

export default function EditRecommendationCategoryDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  amDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveRecommendationCategory = _handleSaveRecommendationCategory;
  vm.IsValidControl = _IsValidControl;
  vm.contentPaneIsFaded = false;
  vm.currentRecommendationCategoryId = 0;
  vm.newRecommendationCategory = { ...vm.recommendationCategory };

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    _refresh().then(() => {
      dfdActivate.resolve();
    });

    dfdActivate.promise.then(() => {
      // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
    });
  }

  function _handleSaveRecommendationCategory() {
    _saveRecommendationCategory();
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editRecommendationCategoryDialog);
  }

  function _saveRecommendationCategory() {
    const dfdSave = $q.defer();

    if ($scope.editAMRecommendationCategoryForm.$valid) {
      amDataService.saveRecommendationCategory(vm.newRecommendationCategory).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the Recommendation Category.');
        } else {
          const savedRecommendationCategory = response.data;
          const isNew = vm.newRecommendationCategory.recommendationCategoryId <= 0;

          angular.extend(vm.newRecommendationCategory, savedRecommendationCategory);
          angular.extend(vm.recommendationCategory, vm.newRecommendationCategory);

          alerts.success('The Recommendation Category has been saved successfully.');

          if (isNew) {
            $rootScope.$broadcast('refreshAMRecommendationCategories', { auditId: vm.newRecommendationCategory.auditId });
          } else {
            $rootScope.$broadcast('refreshAMRecommendationCategory',
              { recommendationCategoryId: vm.newRecommendationCategory.recommendationCategoryId });
          }

          ssDialogService.hide(ssDialogService.dialogs.auditTrail.editRecommendationCategoryDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }

  function _refresh() {
    vm.isProcessingComplete = false;
    const dfdRefresh = $q.defer();
    if (vm.newRecommendationCategory) {
      vm.currentRecommendationCategoryId = vm.newRecommendationCategory.recommendationCategoryId;
    }

    vm.isProcessingComplete = true;
    dfdRefresh.resolve();
    return dfdRefresh.promise;
  }

  // validation
  function _IsValidControl(ctrl) {
    return ($scope.editAMRecommendationCategoryForm)
      && (($scope.editAMRecommendationCategoryForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

EditRecommendationCategoryDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'amDataService'
];
